import React from 'react';
import { Box, Button, Flex, HStack, Text } from '@chakra-ui/react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { Pageable } from '../domain/response-wrapper';

interface PaginatorFooterProps {
  pageable: Pageable;
  total_elements: number;
  onPreviousPage: () => void;
  onNextPage: () => void;
}

export const PaginatorFooter = (props: PaginatorFooterProps) => {
  const { pageable: { page_number, page_size }, total_elements, onPreviousPage, onNextPage } = props;
  const pageCount = page_size > 0 ? Math.ceil(total_elements / page_size) : 0;
  const hasResults = pageCount > 0;
  const firstResult = hasResults ? page_number * page_size + 1 : 0;
  const lastResult = hasResults ? Math.min((page_number + 1) * page_size, total_elements) : 0;
  const currentPage = hasResults ? page_number + 1 : 0;

  return (
    <Flex
      bg="neutral.200"
      borderRadius="md"
      flexShrink={0}
      flexDirection="row"
      justifyContent="space-between"
      padding="xl"
    >
      <Text fontSize="sm" fontWeight="medium">Items por página {page_size}</Text>
      <HStack spacing="l">
        <Text fontSize="sm" fontWeight="medium">
          Resultados {firstResult} - {lastResult} de {total_elements}
        </Text>
        <Text fontSize="sm" fontWeight="medium">
          Página {currentPage} de {pageCount}
        </Text>
      </HStack>

      <Box>
        <Button variant="link" onClick={() => onPreviousPage()}
                isDisabled={!page_number}><IoIosArrowBack /></Button>
        <Button variant="link" onClick={() => onNextPage()}
                isDisabled={page_number >= pageCount - 1}><IoIosArrowForward /></Button>
      </Box>
    </Flex>
  );
};
